import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  obtenerProductos,
  obtenerCategorias,
  crearCategoria,
  obtenerProveedores,
  crearProveedor,
  crearIngreso,
  crearProducto,
} from "../redux/actions/index";
import SweetAlert from "sweetalert2";
import axios from "axios";

const Ingreso = () => {
  const dispatch = useDispatch();
  const productos = useSelector((state) => state.productos);
  const categorias = useSelector((state) => state.categorias);
  const proveedores = useSelector((state) => state.proveedores);
  const error = useSelector((state) => state.error);

  const [proveedorSeleccionado, setProveedorSeleccionado] = useState("");
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [productoActual, setProductoActual] = useState(null);
  const [cantidad, setCantidad] = useState(1);
  const [esPrestamo, setEsPrestamo] = useState(false);

  useEffect(() => {
    dispatch(obtenerProductos());
    dispatch(obtenerCategorias());
    dispatch(obtenerProveedores());
  }, [dispatch]);

  const agregarProductoTemporal = () => {
    if (productoActual && cantidad > 0) {
      const nuevoProducto = {
        id: productoActual.value,
        cantidad: cantidad,
      };
      setProductosSeleccionados([...productosSeleccionados, nuevoProducto]);
      setProductoActual(null); // Resetea el input
      setCantidad(1); // Resetea la cantidad
    } else {
      alert("Selecciona un producto y una cantidad válida.");
    }
  };

  const handleCrearIngreso = () => {
    if (!proveedorSeleccionado || productosSeleccionados.length === 0) {
      SweetAlert.fire(
        "Error",
        "Selecciona un proveedor y al menos un producto",
        "error"
      );
      return;
    }
    // El usuario lo toma el backend de la sesion
    const ingresoData = {
      proveedorId: proveedorSeleccionado,
      productos: productosSeleccionados,
    };

    dispatch(crearIngreso(ingresoData))
      .then(() => {
        SweetAlert.fire("Éxito", "Ingreso creado correctamente", "success");
        productosSeleccionados.forEach(async (prodSeleccionado) => {
          const producto = productos.find(
            (prod) => prod.id === prodSeleccionado.id
          );
          const categoriaNombre = categorias.find(
            (cat) => cat.id === producto.categoriaId
          );
    
          if (producto) {
            try {
              // await axios.post("/api/imprimir", {
              //   nombre: producto.nombre,
              //   codigo_barras: producto.codigoBarras,
              //   descripcion: producto.descripcion,
              //   stock: producto.stock,
              //   categoria: categoriaNombre.nombre,
              //   cantidad: prodSeleccionado.cantidad,
              // });
            } catch (error) {
              console.error(
                `Error al imprimir el producto ${producto.nombre}:`,
                error
              );
            }
          } else {
            console.warn(
              `Producto con ID ${prodSeleccionado.id} no encontrado.`
            );
          }
        });
      })
      .catch((error) => {
        SweetAlert.fire(
          "Error",
          error.message || "No se pudo crear el ingreso",
          "error"
        );
      });
    setProductosSeleccionados([]);
    setProveedorSeleccionado("");
  };

  const handleCrearProducto = async () => {
    const categoriaOptions = categorias
      .map((cat) => `<option value="${cat.id}">${cat.nombre}</option>`)
      .join("");
  
    const unidadOptions = [
      { value: "kg", label: "Kilogramo (kg)" },
      { value: "g", label: "Gramo (g)" },
      { value: "t", label: "Tonelada (t)" },
      { value: "l", label: "Litro (l)" },
      { value: "ml", label: "Mililitro (ml)" },
      { value: "m", label: "Metro (m)" },
      { value: "cm", label: "Centímetro (cm)" },
      { value: "mm", label: "Milímetro (mm)" },
      { value: "pz", label: "Pieza (pz)" },
      { value: "caja", label: "Caja" },
      { value: "paq", label: "Paquete (paq)" },
      { value: "rollo", label: "Rollo" },
      { value: "bot", label: "Botella" },
      { value: "bid", label: "Bidón" },
      { value: "barr", label: "Barril" },
      { value: "saco", label: "Saco" },
      { value: "bulto", label: "Bulto" },
      { value: "fardo", label: "Fardo" },
      { value: "tarro", label: "Tarro" },
      { value: "sobre", label: "Sobre" },
      { value: "granel", label: "Granel" },
      { value: "unidad", label: "Unidad" },
      { value: "doc", label: "Docena" },
      { value: "par", label: "Par" },
      { value: "hoja", label: "Hoja" },
      { value: "m2", label: "Metro cuadrado (m²)" },
      { value: "m3", label: "Metro cúbico (m³)" },
      { value: "kwh", label: "Kilovatio hora (kWh)" },
      { value: "cc", label: "Centímetro cúbico (cc)" },
      { value: "gal", label: "Galón" },
      { value: "lb", label: "Libra (lb)" },
      { value: "oz", label: "Onza (oz)" },
    ]
      .map((unidad) => `<option value="${unidad.value}">${unidad.label}</option>`)
      .join("");
  
    SweetAlert.fire({
      title: "Crear Nuevo Producto",
      html: `
        <input id="nombre" class="swal2-input" placeholder="Nombre del Producto">
        <textarea id="descripcion" class="swal2-textarea" placeholder="Descripción"></textarea>
        <select id="categoria" class="swal2-select">${categoriaOptions}</select>
        <input id="nuevaCategoria" class="swal2-input" placeholder="Nueva Categoría (dejar vacío si ya está seleccionada)">
        <select id="unidad" class="swal2-select">
          <option value="">Seleccionar unidad de medida</option>
          ${unidadOptions}
        </select>
        <div style="margin-top: 10px;">
          <label>
            <input type="checkbox" id="esPrestamoCheckbox"> ¿Es un préstamo?
          </label>
        </div>
      `,
      focusConfirm: false,
      preConfirm: async () => {
        const nombre = document.getElementById("nombre").value;
        const descripcion = document.getElementById("descripcion").value;
        const categoriaId = document.getElementById("categoria").value;
        const nuevaCategoria = document.getElementById("nuevaCategoria").value;
        const unidadMedida = document.getElementById("unidad").value;
        const esPrestamo = document.getElementById("esPrestamoCheckbox").checked;
  
        if (!nombre || (!categoriaId && !nuevaCategoria) || !unidadMedida) {
          SweetAlert.showValidationMessage("Debes completar todos los campos obligatorios");
          return;
        }
  
        try {
          let productoCreado;
  
          if (nuevaCategoria) {
            const nuevaCategoriaCreada = await dispatch(crearCategoria({ nombre: nuevaCategoria }));
            productoCreado = await dispatch(
              crearProducto({
                nombre,
                descripcion,
                categoriaId: nuevaCategoriaCreada.id,
                unidadMedida,
                esPrestamo,
              })
            );
          } else {
            productoCreado = await dispatch(
              crearProducto({
                nombre,
                descripcion,
                categoriaId,
                unidadMedida,
                esPrestamo,
              })
            );
          }
  
          if (productoCreado) {
            setProductoActual({ value: productoCreado.id, label: productoCreado.nombre });
            SweetAlert.fire("Éxito", "Producto creado correctamente", "success");
          }
        } catch (error) {
          SweetAlert.fire("Error", error.message, "error");
        }
      },
    });
  };

  const handleCrearNuevoProveedor = async () => {
    const { value: datosProveedor } = await SweetAlert.fire({
      title: "Crear Nuevo Proveedor",
      html: `
      <input id="nombre" class="swal2-input" placeholder="Nombre" required>
      <input id="direccion" class="swal2-input" placeholder="Dirección">
      <input id="email" class="swal2-input" placeholder="Email" type="email">
      `,
      focusConfirm: false,
      preConfirm: () => {
        return {
          nombre: document.getElementById("nombre").value,
          direccion: document.getElementById("direccion").value,
          email: document.getElementById("email").value,
        };
      },
      showCancelButton: true,
    });
    if (datosProveedor && datosProveedor.nombre) {
      try {
        await dispatch(crearProveedor(datosProveedor));
        SweetAlert.fire("Éxito", "Proveedor creado correctamente", "success");
        dispatch(obtenerProveedores());
      } catch (error) {
        SweetAlert.fire("Error", "Hubo un error al crear el proveedor", "error");
      }
    } else {
      SweetAlert.fire("Error", "El nombre es obligatorio", "error");
    }
  };

  const detailprod = productosSeleccionados
    ?.map((e) => {
      const producto = productos.find((p) => p.id === e.id);
      if (producto) {
        return {
          ...producto,
          cantidad: e.cantidad,
        };
      }
      return null;
    })
    .filter(Boolean);

  const productOptions = productos.map((producto) => ({
    value: producto.id,
    label: producto.nombre,
  }));

  return (
    <div className="grid p-4 grid-cols-1 gap-4 md:grid-cols-2 md:gap-8 bg-backgroundClaro">
      <div className="rounded-lg h-screen bg-backgroundOscuro">
        <h1 className="flex text-textoClaro justify-center text-4xl font-bold">
          Registrar Ingreso de Productos
        </h1>
        <div className="m-4">
          <label className="block text-textoClaro text-lg font-bold mb-2">
            Proveedor:
          </label>
          <select
            value={proveedorSeleccionado}
            onChange={(e) => setProveedorSeleccionado(e.target.value)}
            className="w-4/5 px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500 bg-backgroundClaro text-textoOscuro"
          >
            <option
              value=""
              className="w-4/5 px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500 bg-backgroundClaro text-textoOscuro"
            >
              Seleccione un proveedor
            </option>
            {proveedores.map((proveedor) => (
              <option
                key={proveedor.id}
                className="w-4/5 px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500 bg-backgroundClaro text-textoOscuro"
                value={proveedor.id}
              >
                {proveedor.nombre}
              </option>
            ))}
          </select>
          <button
            onClick={handleCrearNuevoProveedor}
            className="bg-green-900 flex items-center my-2 p-2 rounded-md text-textoClaro font-bold text-lg hover:bg-green-600 shadow-lg shadow-green-500/50"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-textoOscuro"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 5v14m-7-7h14"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Crear nuevo proveedor
          </button>
        </div>
        <div className="m-4">
          <label className="block text-textoClaro text-lg font-bold mb-2">
            Producto:
          </label>
          <Select
            options={productOptions}
            value={productoActual}
            onChange={setProductoActual}
            className="w-4/5 border rounded-md focus:outline-none focus:border-blue-500 bg-backgroundClaro text-textoOscuro"
            placeholder="Seleccione un producto"
          />
          <label className="block text-textoClaro text-lg font-bold mb-2">
            Cantidad:
          </label>
          <input
            type="number"
            min="1"
            className="w-4/5 px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500 bg-backgroundClaro text-textoOscuro"
            value={cantidad}
            onChange={(e) => {
              const value = parseInt(e.target.value, 10);
              if (!isNaN(value)) {
                setCantidad(value);
              } else {
                setCantidad("");
              }
            }}
          />
          <div className="flex gap-8">
            <button
              className="bg-green-900 flex items-center my-2 p-2 rounded-md text-textoClaro font-bold text-lg hover:bg-green-600 shadow-lg shadow-green-500/50"
              onClick={agregarProductoTemporal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 5v14m-7-7h14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Añadir al Ingreso
            </button>
            <button
              className="bg-green-900 flex items-center my-2 p-2 rounded-md text-textoClaro font-bold text-lg hover:bg-green-600 shadow-lg shadow-green-500/50"
              onClick={handleCrearProducto}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 5v14m-7-7h14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Crear Nuevo Producto
            </button>
          </div>
        </div>
        <button
          onClick={handleCrearIngreso}
          className="bg-green-900 flex items-center m-4 p-2 rounded-md text-textoClaro font-bold text-lg hover:bg-green-600 shadow-lg shadow-green-500/50"
        >
          Registrar Ingreso
        </button>
      </div>

      <div className="rounded-lg h-screen bg-backgroundOscuro">
        {productosSeleccionados?.length ? (
          <div className="mx-auto flex w-full flex-col justify-center px-5 pt-0 md:h-[unset] md:max-w-[95%] mt-10">
            <div className="h-full w-full rounded-lg ">
              <div className="rounded-lg border bg-card text-card-foreground shadow-sm h-full w-full border-zinc-200 p-0 dark:border-zinc-800 sm:overflow-auto">
                <div className="overflow-x-scroll xl:overflow-x-hidden">
                  <div className="relative w-full overflow-auto">
                    <table className="caption-bottom text-sm w-full">
                      <thead className="border-b-2 p-6 border-zinc-800">
                        <tr className="border-zinc-800">
                          <th
                            className="h-12 px-4 align-middle border-r-2 font-medium text-muted-foreground cursor-pointer pl-5 pr-4 pt-2 text-start border-zinc-800"
                            colspan="1"
                          >
                            <p className="text-m font-semibold text-textoClaro">
                              Nombre Producto
                            </p>
                          </th>

                          <th
                            className="h-12 px-4 align-middle border-r-2 font-medium text-muted-foreground cursor-pointer pl-5 pr-4 pt-2 text-start border-zinc-800"
                            colspan="1"
                          >
                            <p className="text-m font-semibold text-textoClaro">
                              Categoria
                            </p>
                          </th>
                          <th
                            className="h-12 px-4 align-middle border-r-2 font-medium text-muted-foreground cursor-pointer pl-5 pr-4 pt-2 text-start border-zinc-800"
                            colspan="1"
                          >
                            <p className="text-m font-semibold text-textoClaro">
                              Cantidad
                            </p>
                          </th>
                          <th
                            className="h-12 px-4 align-middle border-r-2 font-medium text-muted-foreground cursor-pointer pl-5 pr-4 pt-2 text-start border-zinc-800"
                            colspan="1"
                          >
                            <p className="text-m font-semibold text-textoClaro">
                              Stock Actual
                            </p>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {detailprod ? (
                          detailprod.map((e) => (
                            <tr className="border-b-2 border-zinc-800 transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted px-6 dark:hover:bg-gray-900">
                              <td className="p-4 align-middle w-max border-r-2 py-5 pl-5 pr-4 border-zinc-800">
                                <p className="text-sm font-medium text-textoClaro">
                                  {e?.nombre}
                                </p>
                              </td>
                              <td className="p-4 align-middle w-max border-r-2 py-5 pl-5 pr-4 border-zinc-800">
                                <div className="flex w-full items-center gap-[14px]">
                                  <p className="text-sm font-medium text-zinc-950 dark:text-white">
                                    {e?.categoria?.nombre}
                                  </p>
                                </div>
                              </td>
                              <td className="p-4 align-middle w-max border-r-2 py-5 pl-5 pr-4 border-zinc-800">
                                <div className="flex w-full items-center gap-[14px]">
                                  <p className="text-sm font-medium text-zinc-950 dark:text-white">
                                    {e.cantidad}
                                  </p>
                                </div>
                              </td>
                              <td className="p-4 align-middle w-max border-r-2 py-5 pl-5 pr-4 border-zinc-800">
                                <div className="flex w-full items-center gap-[14px]">
                                  <p className="text-sm font-medium text-zinc-950 dark:text-white">
                                    {e.stock}
                                  </p>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Ingreso;
